<template>
  <div class="product-wrap">
    <div class="header-title">产品管理</div>
    <div class="flex">
      <div class="filter">
        <el-input
          v-model="formSearch.search"
          style="width: 200px"
          placeholder="请输入唯一标识/产品名称"
        ></el-input>
        <el-select
          filterable
          collapse-tags
          multiple
          class="multiple-select"
          placeholder="请选择发布市场"
          v-model="formSearch.publishMarketList"
        >
          <el-option
            v-for="item in publishMarketOptions"
            :key="item.publishMarket"
            :label="item.publishMarketName"
            :value="item.publishMarket"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          collapse-tags
          multiple
          class="multiple-select"
          placeholder="请选择平台类型"
          v-model="formSearch.publishPlatformList"
        >
          <el-option
            v-for="item in marketTypeList"
            :key="item.refId"
            :label="item.name"
            :value="item.refId"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          collapse-tags
          multiple
          class="multiple-select"
          placeholder="请选择投放渠道"
          v-model="formSearch.mediaSourceList"
        >
          <el-option
            v-for="item in mediaSourceOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          collapse-tags
          multiple
          class="multiple-select"
          placeholder="请选择工作室"
          v-model="formSearch.productGroupNameList"
        >
          <el-option
            v-for="item in groupList"
            :key="item.refId"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          collapse-tags
          multiple
          class="multiple-select"
          placeholder="请选择小组"
          v-model="formSearch.squadNameList"
        >
          <el-option
            v-for="item in studioList"
            :key="item.refId"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="formSearch.accountGroupCodes"
          style="margin-left: 12px; width: 200px"
          placeholder="请选择域名组"
          clearable
        >
          <el-option
            v-for="item in accountGroupCodeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          filterable
          collapse-tags
          multiple
          class="multiple-select"
          placeholder="请选择投放主体"
          v-model="formSearch.deliverySubIdList"
        >
          <el-option
            v-for="item in deliverySubList"
            :key="item.id"
            :label="item.deliveryName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button style="margin-left: 16px" @click="resetFilter"
          >重置</el-button
        >
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <el-button
      icon="el-icon-plus"
      type="primary"
      @click="handleAdd"
      style="margin-bottom: 12px"
      >添加产品</el-button
    >
    <el-button @click="downTemplate">下载模板</el-button>
    <el-button @click="uploadVisible = true">批量上传</el-button>
    <el-table
      :height="tableHeight"
      :data="list"
      ref="table"
      v-loading="loading"
    >
      <el-table-column
        v-for="item of columns"
        :label="item.label"
        :key="item.prop"
        :prop="item.prop"
        :min-width="item.width"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'mediaSourceList'">
            <div v-if="scope.row[item.prop]">
              <!-- <div v-for="child in scope.row[item.prop]" :key="child">
                {{ child }}
              </div> -->
              <el-tooltip
                class="item"
                effect="dark"
                :content="`${scope.row[item.prop].join(',')}`"
                placement="top-start"
              >
                <p class="table-item">{{ scope.row[item.prop].join(",") }}</p>
              </el-tooltip>
            </div>
            <span v-else>--</span>
          </div>
          <div v-else-if="item.prop === 'deliverySubType'">
            <span v-if="scope.row[item.prop]">
              {{ scope.row[item.prop] == 1 ? "公司" : "个人" }}
            </span>
            <span v-else>--</span>
          </div>
          <div v-else-if="item.prop === 'gravityCallBackLink'">
            <div v-if="scope.row.isGravity == 1">
              <el-popover
                placement="right"
                width="500"
                trigger="hover"
                :content="scope.row[item.prop]"
              >
                <span class="gravity-link" slot="reference">
                  {{ scope.row[item.prop] }}
                </span>
              </el-popover>
              <i
                @click="copyData(scope.row[item.prop])"
                class="el-icon-document-copy copy-icon"
              ></i>
            </div>
            <span v-else>--</span>
          </div>
          <div v-else-if="item.prop === 'realizationType'">
            <span v-if="scope.row[item.prop]">
              {{
                scope.row[item.prop] == 1
                  ? "IAA"
                  : scope.row[item.prop] == 2
                  ? "IAP"
                  : "IAA+IAP"
              }}
            </span>
            <span v-else>--</span>
          </div>
          <div v-else-if="item.prop === 'popuStatus'">
            {{
              scope.row[item.prop] == 1
                ? "开启"
                : scope.row[item.prop] == 0
                ? "关闭"
                : "--"
            }}
          </div>
          <!-- 引力归因时间 -->
          <div v-else-if="item.prop === 'gravityStartDate'">
            {{
              scope.row[item.prop].length === 1 &&
              !scope.row[item.prop][0].time[0] &&
              !scope.row[item.prop][0].time[1]
                ? "-"
                : scope.row[item.prop]
                    .map((i) => {
                      const timeCopy = [
                        i.time[0],
                        i.time[1] ? i.time[1] : "至今",
                      ];
                      return timeCopy.join("~");
                    })
                    .join(",")
            }}
          </div>
          <span v-else> {{ scope.row[item.prop] || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150px" label="操作" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button
            type="text"
            class="edit-btn"
            size="medium"
            @click="conAdCount(scope.row)"
            >关联广告账号
          </el-button>
          <el-button
            type="text"
            class="edit-btn"
            size="medium"
            @click="checkAdCount(scope.row)"
            >查看关联账号</el-button
          > -->
          <el-button
            type="text"
            class="edit-btn"
            size="medium"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            class="delete-btn"
            size="medium"
            style="color: red"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      @getCurrentPage="changePage"
      @handleSizeChange="changePageSize"
    ></self-pagination>
    <dialog-form
      ref="dialogFormRef"
      @closeDialogForm="changePage(1)"
      addormodify="add"
    ></dialog-form>
    <con-ad-modal ref="conAdModalRef"></con-ad-modal>
    <!-- 查看关联账号 -->
    <check-account-modal ref="checkModal"></check-account-modal>
    <UploadExcel
      :uploadVisible="uploadVisible"
      @closeUploadFile="closeUploadFile"
    ></UploadExcel>
  </div>
</template>

<script>
import { columns } from "./config";
import DialogForm from "./dialogForm";
import { copyText } from "@/utils/tool.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import {
  getTagPropertySelectList,
  getPublishMarketsList,
} from "@/api/property";
import ConAdModal from "./conAdModal.vue";
import UploadExcel from "./UploadExcel.vue";
import CheckAccountModal from "@/pages/account/user-manage/checkAccountModal";
import {
  getmediaSourceFetch,
  groupList,
  squadList,
  getDeliverySubList,
  getProductTableListFetch,
  deleteUserTableItemFetch,
} from "@/api/api";
export default {
  components: { DialogForm, ConAdModal, CheckAccountModal, UploadExcel },

  data() {
    return {
      columns,
      formSearch: {
        search: "",
        publishMarketList: [],
        publishPlatformList: [],
        mediaSourceList: [],
        productGroupNameList: [],
        squadNameList: [],
        deliverySubIdList: [],
        accountGroupCodes: null,
      },
      list: [],
      marketTypeList: [],
      publishMarketOptions: [],
      mediaSourceOptions: [],
      groupList: [],
      studioList: [],
      deliverySubList: [],
      accountGroupCodeList: JSON.parse(
        localStorage.getItem("accountGroupCodeList") || "[]"
      ),
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableHeight: window.innerHeight - 280,
      loading: false,
      uploadVisible: false,
    };
  },

  computed: {},

  watch: {},
  mounted() {
    this.initSelect();
    this.searchData();
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },

  methods: {
    initSelect() {
      getTagPropertySelectList({ type: 10 }).then((res) => {
        this.marketTypeList = res.data;
      });
      getmediaSourceFetch().then((res) => {
        this.mediaSourceOptions = res.mediaList;
      });
      getPublishMarketsList().then((res) => {
        this.publishMarketOptions = res.data;
      });
      groupList().then((res) => {
        this.groupList = res.data;
      });
      squadList().then((res) => {
        this.studioList = res.data;
      });
      getDeliverySubList({
        pageNum: 1,
        pageSize: 99999,
      }).then((res) => {
        this.deliverySubList = res.data.list;
      });
    },
    refresh() {
      this.tableHeight = window.innerHeight - 280;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    resetFilter() {
      this.formSearch = {
        search: "",
        publishPlatformList: [],
        publishMarketList: [],
        mediaSourceList: [],
        productGroupNameList: [],
        squadNameList: [],
        deliverySubIdList: [],
        accountGroupCodes: null,
      };
      this.changePage(1);
    },
    handleSearch() {
      this.changePage(1);
    },
    searchData() {
      this.loading = true;
      getProductTableListFetch({
        offset: (this.pageData.page - 1) * this.pageData.size,
        limit: this.pageData.size,
        ...this.formSearch,
        accountGroupCodes: this.formSearch.accountGroupCodes
          ? [this.formSearch.accountGroupCodes]
          : undefined,
      }).then((res) => {
        if (res.code == "0000") {
          this.list = res.products.map((i) => ({
            ...i,
            // 引力归因时间
            gravityStartDate: i.gravityStartDate
              ? i.gravityStartDate.split(",").map((e) => ({
                  time: [e.split("~")[0], e.split("~")[1]],
                }))
              : [
                  {
                    time: ["", ""],
                  },
                ],
          }));

          this.pageData.total = res.total;
        }
        this.loading = false;
      });
    },
    handleAdd() {
      this.$refs.dialogFormRef.showModal("add");
    },
    handleEdit(data) {
      this.$refs.dialogFormRef.showModal("edit", data);
    },
    handleDelete(data) {
      this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteUserTableItemFetch({ id: data.id }).then((res) => {
          if (res.code == "0000") {
            this.$message.success("删除成功");
            this.changePage(1);
          }
        });
      });
    },
    copyData(data) {
      if (data && copyText(data)) {
        this.$message({
          message: "引力检测链接复制成功",
          type: "success",
        });
      }
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    conAdCount(data) {
      this.$refs.conAdModalRef.showModal(data);
    },
    checkAdCount(data) {
      let title = data.appName + "关联的广告账号";
      this.$refs.checkModal.showModal(data, title, "product");
    },
    // 下载模板
    downTemplate() {
      let headers = {};
      const productList = [
        {
          // 唯一标识
          afid: "必填",
          // AF_Dev key
          afDevKey: "非必填",
          firebaseApiSecret: '非必填',
          // 产品名称
          appName: "必填",
          // 平台类型
          publishPlatformName: "必填",
          // 投放渠道
          mediaSourceList: "非必填",
          // 原始ID
          originId: "非必填",
          // 投放名
          launchName: "非必填",
          // 主体类别
          deliverySubType: "非必填",
          // 投放主体
          deliveryName: "非必填",
          // af账号ID
          afAccountName: "非必填",
          // 变现形式
          realizationType: "非必填",
          // 域名组
          accountGroupCode: "必填",
        },
      ];
      columns.forEach((item) => {
        if (
          [
            "afid",
            "afDevKey",
            "firebaseApiSecret",
            "appName",
            "publishPlatformName",
            "mediaSourceList",
            "originId",
            "launchName",
            "deliverySubType",
            "deliveryName",
            "afAccountName",
            "realizationType",
            "accountGroupCode",
            "gravityStartDate",
          ].includes(item.prop)
        ) {
          headers[item.prop] = item.label;
        }
      });
      downLoadWrokSheet(productList, "产品管理上传模板.xlsx", headers);
    },
    closeUploadFile() {
      this.uploadVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.product-wrap {
  margin: 16px;
  height: calc(100vh - 110px);
  padding: 16px 24px 16px 24px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .header-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    flex: 1;
    margin-bottom: 16px;
  }
  .filter {
    flex: 1;
    margin-bottom: 16px;
    .multiple-select {
      margin-left: 16px;
      width: 220px;
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .table-item {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .gravity-link {
    overflow: hidden; // 溢出的内容隐藏
    text-overflow: ellipsis; // 溢出的部分用省略号...显示
    -webkit-line-clamp: 2; // 行数
    display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
    -webkit-box-orient: vertical; // 设置或检索伸缩盒对象的子元素的排列方式
  }
  .copy-icon {
    flex-shrink: 0;
    display: inline-block;
    color: rgba(24, 144, 255, 1);
    font-size: 16px;
    cursor: pointer;
    margin-left: 4px;
  }
}
</style>
